import React from 'react';
export function PainPointSection() {
  return <section className="bg-gray-50 py-16 px-4" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-8 font-['Oswald'] uppercase" data-id="element-88">
          Si enseñás Ciencias Naturales, dejame hacerte una pregunta honesta
        </h2>

        <div className="bg-white p-8 md:p-10 rounded-xl shadow-sm border-l-4 border-[#c0392b]" data-id="element-89">
          <h3 className="text-2xl font-bold text-[#c0392b] mb-6" data-id="element-90">
            ¿Te pasa que preparar la clase te cansa más que darla?
          </h3>

          <div className="space-y-4 text-lg text-gray-700" data-id="element-91">
            <p data-id="element-92">
              No porque no sepas el contenido. No porque no seas buena docente.
            </p>
            <p data-id="element-93">Sino porque cada unidad parece empezar desde cero.</p>

            <ul className="pl-6 space-y-2 italic text-gray-600 border-l-2 border-gray-200 ml-2 my-6" data-id="element-94">
              <li data-id="element-95">Buscar actividades.</li>
              <li data-id="element-96">Adaptar PDFs.</li>
              <li data-id="element-97">Armar juegos.</li>
              <li data-id="element-98">Diseñar evaluaciones.</li>
              <li data-id="element-99">Organizar material suelto.</li>
            </ul>

            <p data-id="element-100">Y cuando finalmente entrás al aula… ya estás agotada.</p>

            <p className="font-bold text-xl text-gray-900 mt-6" data-id="element-101">
              Enseñar el cuerpo humano no debería sentirse así.
            </p>
          </div>
        </div>
      </div>
    </section>;
}